// extracted by mini-css-extract-plugin
module.exports = {"container":"primary_icons-module--container--1MKe2","item":"primary_icons-module--item---ot4m"};